import { https } from 'core/services/https';
import { ICheckoutCartDetailDTO, ICheckoutCartDetailParams } from './checkout.dto';

export const baseUrl = '/v1/checkout';
export const checkoutData = {
  getCheckoutDetail: async (customerId: number, params?: ICheckoutCartDetailParams) => {
    const data = await https.get<ICheckoutCartDetailDTO>(baseUrl, {
      params,
      headers: { 'Gtm-Customer-id': customerId },
    });

    return data;
  },
};
